import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './components/_admin-layout/home/home.component';
import { NotFoundComponent } from './components/home/not-found/not-found.component';
import { PublicLayoutComponent } from './components/_public-layout/public-layout.component';
import { EmpresaComponent } from './components/_public-layout/pages/empresa/empresa.component';
import { AdminLayoutComponent } from './components/_admin-layout/admin-layout.component';
import { AdminModule } from './components/admin/admin.module';
import { AdminComponent } from './components/admin/admin/admin.component';
import { AuthGuard } from './components/shared/authentication/auth-guard';
import { SucessoComponent } from './components/_public-layout/pages/sucesso/sucesso.component';
import { AnaliseComponent } from './components/_public-layout/pages/analise/analise.component';
import { LoginEmpresaComponent } from './components/_public-layout/pages/login/login-empresa.component';
import { IndicacaoComponent } from './components/_public-layout/pages/indicacao/indicacao.component';
import { EmpresaEditalComponent } from './components/_public-layout/pages/editais/empresa-edital-root.component';
import { AceiteEditalComponent } from './components/_public-layout/pages/editais/aceite/aceite-edital.component';

const AppRoutes: Routes = [
    { path: '', component: AdminLayoutComponent,
        children: [
            { path: '', redirectTo: 'home', pathMatch: 'full'},
            { path: 'home', component: HomeComponent },
        ]
     },
    { path: '', component: PublicLayoutComponent,
        children: [
            { path: 'cadastro', redirectTo: 'cadastro/edital/:idFase', pathMatch: 'full'},
            { path: 'cadastro/edital/:idFase', component: EmpresaComponent },
            { path: 'sucesso', redirectTo: 'cadastro/sucesso', pathMatch: 'full'},
            { path: 'cadastro/sucesso', component: SucessoComponent },
            { path: 'analise', redirectTo: 'cadastro/analise', pathMatch: 'full'},
            { path: 'cadastro/analise', component: AnaliseComponent },
            { path: 'login-empresa', component: LoginEmpresaComponent, pathMatch: 'full' },
            { path: 'recuperar-senha', component: LoginEmpresaComponent, pathMatch: 'full' },
            { path: 'indicacao', redirectTo: 'cadastro/indicacao', pathMatch: 'full'},
            { path: 'cadastro/indicacao', component: IndicacaoComponent },
            { path: 'cadastro/empresa', component: EmpresaEditalComponent, pathMatch: 'full' },
            { path: 'cadastro/aceite/:idFase', component: AceiteEditalComponent, pathMatch: 'full' },
        ]
     },
    { path: '**', component: AdminLayoutComponent,
        children: [
            { path: '', component: NotFoundComponent },            
        ]
    },
];

export const AppRouting = RouterModule.forRoot(AppRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts